const $ = window.jQuery;
// Marker image path will be set from WordPress asset_path
const markerImage = '/wp/wp-content/themes/karappo/assets/image/access/map-marker@2x.png';

let resizeTimer = null;
const initMap = function (lat, lng, zoom = 17) {
  // 毎resizeで実行されないように
  // _.debounce的なことをしている
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    // SPモード
    if (window.matchMedia('(max-width:767px)').matches) {
      // 中心・ズーム・マーカーサイズ変更
      zoom -= 1;
    }

    const marker = new window.google.maps.LatLng(lat, lng);
    const mapId = 'map';
    const title = 'KARAPPO';
    const marker_latlan = marker;
    const center_latlan = marker;
    const options = {
      zoom,
      center: marker_latlan,
      mapId: '46c57f992822ec17a08bc485', // Required for AdvancedMarkerElement
      disableDefaultUI: true,
      type: false,
      zoomControl: true,
      scrollwheel: false,
    }

    // Note: Map styles are controlled via Google Cloud Console when using mapId
    // To configure styles for this map:
    // 1. Go to: https://console.cloud.google.com/google/maps-apis/studio/maps
    // 2. Select Map ID: 46c57f992822ec17a08bc485
    // 3. Click "Style" tab and use the visual editor to customize:
    //    - Transit: Desaturate (-100 saturation)
    //    - Administrative: Hide
    //    - POI: Desaturate (-100 saturation)
    //    - Water: Light gray (#e9e9e9)
    //    - Road: Desaturate (-100 saturation)
    //    - Landscape: Desaturate (-100 saturation), Lightness +10
    //    - Labels: Hide all except transit stations

    // generate map
    const map = new window.google.maps.Map(document.getElementById(mapId), options);

    // Create custom marker element
    const markerImg = document.createElement('img');
    markerImg.src = markerImage;
    markerImg.style.width = '60px';
    markerImg.style.height = '36px';

    new window.google.maps.marker.AdvancedMarkerElement({
      position: marker_latlan,
      map: map,
      title: title,
      content: markerImg,
    });

    // Note: Map styles must be configured in Google Cloud Console when using mapId
    // See: https://console.cloud.google.com/google/maps-apis/studio/maps
    // Select your Map ID (46c57f992822ec17a08bc485) and customize the style using the UI editor

    if (center_latlan) {
      map.setCenter(center_latlan);
    }
  }, 500);
}

// IE対策、兼Chromeでも最初の読み込み時に高さがうまく設定されていなかったため
window.resizeMap = () => {
  const map = $('#map')
  if(map) {
    const mapHeight = map.outerHeight()
    // 前回initMap時と高さが変わっていたら再度initMap
    if(!mapHeight || map.attr('data-height') != String(mapHeight)) {
      map.attr('data-height', mapHeight)
      initMap(map.data('lat'), map.data('lng'), map.data('zoom'))
    }
  }
}

$(window).on('resize', window.resizeMap)
